// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"479":"css/app.7039","2429":"css/admin-app.7039"}[chunkId] + ".css";
};